/**
 * Type of swap stream.
 * tag: 40050
 * @readonly
 * @enum {number} (int)
 */
export enum StreamType {
  /** Payment / cash settlement */
  PaymentCashSettlement = 0,
  /** Physical delivery */
  PhysicalDelivery = 1,
}
